module.exports = __webpack_public_path__ + "img/sosmed-wa.80e01b96.png";